function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-announcements-state_svg__filter0_d_961:34)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43 24a2 2 0 012-2h186a2 2 0 012 2v52a2 2 0 01-2 2H50l-7 5V24z",
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "#0085FF",
  fillOpacity: 0.3,
  d: "M66 31h157v10H66zM66 46h157v10H66zM66 61h50v10H66z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  d: "M53 32h3v9h-3zM53 43h3v3h-3z"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 106,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 106,
  r: 13,
  fill: "#DBDFE5"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-announcements-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 119,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 101.864,
  r: 6.275,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-announcements-state_svg__filter0_d_961:34",
  x: 35,
  y: 16,
  width: 206,
  height: 77,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_961:34"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_961:34",
  result: "shape"
})));
function SvgEmptyAnnouncementsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "empty-announcements-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 93,
    width: 26,
    height: 26
  }, _ref6), _ref7, _ref8);
}
export default SvgEmptyAnnouncementsState;